import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "21",
  fill: "none",
  viewBox: "0 0 20 21"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M5.83 4.456v-2.5c0-.46.374-.833.834-.833h6.667c.46 0 .833.373.833.833v2.5h3.333c.46 0 .834.373.834.834v11.666c0 .46-.373.834-.834.834h-15a.833.833 0 0 1-.833-.834V5.29c0-.46.373-.834.833-.834zm-2.5 9.167v2.5h13.334v-2.5zm0-1.667h13.334V6.123H3.331zM7.498 2.79v1.666h5V2.79zm1.667 6.666h1.667v1.667H9.164z"
    }, null, -1)
  ]))]))
}
export default { render: render }